import { Helmet } from 'react-helmet';
import KhophieuDetail
  from 'src/components/khophieu-detail/KhophieuDetail';

import {
  Box,
  Container,
} from '@material-ui/core';

import KhophieuListToolbar from '../components/khophieu-detail/KhophieuToolbar';

const Khophieu = () => (
  <>
    <Helmet>
      <title>Quản lý phiếu nhập/xuất kho</title>
    </Helmet>
    <Box
      sx={{
        backgroundColor: 'background.default',
        minHeight: '100%',
        py: 3
      }}
    >
      <Container style={{maxWidth: "100%"}}>
        <KhophieuListToolbar />
        <Box sx={{ pt: 3 }}>
          <KhophieuDetail />
        </Box>
      </Container>
    </Box>
  </>
);

export default Khophieu;
